import React from 'react';
import { logger } from '../../services/loggingService';

export const LoggingTest: React.FC = () => {
  const testLogs = () => {
    console.log('=== Testing Frontend Logging Service ===');
    
    // Test 1: Basic info log
    logger.info('LoggingTest', 'Testing basic info logging', { 
      testValue: 123,
      timestamp: new Date().toISOString() 
    });
    
    // Test 2: Error log
    logger.error('LoggingTest', 'Testing error logging', { 
      errorCode: 'TEST_ERROR',
      severity: 'high' 
    });
    
    // Test 3: User action log
    logger.logUserAction('test_button_click', {
      buttonId: 'logging_test_button',
      location: 'logging_test_component'
    });
    
    // Test 4: Exception log
    try {
      throw new Error('This is a test exception for logging');
    } catch (error) {
      logger.logException('LoggingTest', error as Error, {
        testCase: 'exception_handling',
        intentional: true
      });
    }
    
    // Test 5: Performance log
    logger.logPerformance('test_operation', 1234, {
      operation: 'mock_data_load',
      recordCount: 500
    });
    
    console.log('=== Logging tests completed ===');
    alert('Logging tests sent! Check backend logs and network tab.');
  };
  
  const flushLogs = () => {
    logger.flushNow().then(() => {
      alert('Logs flushed manually!');
    });
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-lg shadow-lg">
      <h2 className="text-xl font-bold mb-4 text-gray-900">
        🧪 Frontend Logging Test
      </h2>
      
      <div className="space-y-3">
        <button 
          onClick={testLogs}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
        >
          Run Logging Tests
        </button>
        
        <button 
          onClick={flushLogs}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
        >
          Flush Logs Now
        </button>
        
        <div className="text-sm text-gray-600 mt-4">
          <p><strong>How to verify:</strong></p>
          <ol className="list-decimal list-inside space-y-1 mt-2">
            <li>Click "Run Logging Tests"</li>
            <li>Check Network tab for POST to /api/v1/logging/client</li>
            <li>Check backend console for log entries</li>
            <li>Check server log files</li>
          </ol>
        </div>
      </div>
    </div>
  );
};
